import { render } from "./editSku.vue?vue&type=template&id=b9ee6572&scoped=true"
import script from "./editSku.vue?vue&type=script&lang=js"
export * from "./editSku.vue?vue&type=script&lang=js"

import "./editSku.vue?vue&type=style&index=0&id=b9ee6572&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ee6572"]])

export default __exports__